import { useSelector } from "react-redux";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Pagination, useMediaQuery } from "@mui/material";

import moment from "moment";
import { Model } from "../../../models/model";
import { Crear } from "../Crear";
import { Tooltip } from "@mui/material";
import NumberFormat from "react-number-format";
import { TasksGantt } from "../TasksGantt";
import { TaskViewSwitch } from "../TaskViewSwitch";
import { TaskDeadline, TaskStatus } from "../TaskIndicators";
import { FiltersMoreOptions } from "../../general/buscadorTasks/FiltersMoreOptions";

const getPathName = (path) => {
  const arrayNames = path.split("/");
  return arrayNames[1];
};

export const TasksModeListGeneral = ({
  setTasksList,
  tasksList,
  filters,
  handleFilters,
  opens,
  origen,
  handleCheckDone,
  dateFilters,
}) => {
  const location = useLocation();
  const pathName = getPathName(location.pathname);
  const { usuariosTarea } = useSelector((state) => state.general);
  const [openAll, setOpenAll] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const page = filters.page || 1;
  const [view, setView] = useState("list");
  const [openMoreFilters, setOpenMoreFilters] = useState(false);
  const activeFilters = [filters.id_ppto, filters.id_responsable, filters.estado, filters.programacion].filter(Boolean).length;

  const handleGetTasks = async (filters, checkOpen = false) => {
    const params = new URLSearchParams(filters).toString();
    const newTasksList = await Model.getAll({
      url: `tasks/all/general/?${params}`,
    });
    /* console.log({ newTasksList }); */

    if (checkOpen) {
      await handleOpenRefresh(tasksList, newTasksList);
    } else {
      setTasksList(newTasksList);
      setOpenAll(true);
    }
  };

  const handleRemoveTask = async (task) => {
    const tasksListUpdated = tasksList?.filter((it) => it.id !== task.id);
    setTasksList(tasksListUpdated);

    if (task?.created) {
      await Model.delete({
        url: `tasks/proyectos/tasks2/${task.id}`,
      });
    }
  };

  const handleOpenAll = () => {
    const newState = !openAll;
    setOpenAll(newState);

    const newHitosListUpdated = tasksList.map((it) => {
      const taskListUpdated = it.subs.map((task) => {
        return {
          ...task,
          show_subs: newState ? true : false,
        };
      });

      return {
        ...it,
        show_subs: newState ? true : false,
        subs: taskListUpdated,
      };
    });

    setTasksList(newHitosListUpdated);
  };

  const handleOpenRefresh = async (previousTaksList, newTasksList) => {
    // hitos
    const hitosListUpdated = newTasksList.map((hito) => {
      const previousStateHito = previousTaksList.find(
        (ph) => ph.id === hito.id,
      );

      // tasks
      const tasksListUpdated = hito?.subs.map((task) => {
        const previousStateTask = previousStateHito?.subs.find(
          (pt) => pt.id === task.id,
        );
        return {
          ...task,
          show_subs: previousStateTask?.show_subs || false,
        };
      });

      return {
        ...hito,
        show_subs: previousStateHito?.show_subs || false,
        subs: tasksListUpdated,
      };
    });

    setTasksList(hitosListUpdated);
  };

  const handleChangePage = (_, value) => {
    handleFilters({ target: { name: "page", value } });
  };

  return (
    <>
      <header className="tasks-page-heading">
        <h1 className="p-title">Tareas</h1>
        <Crear refreshObj={{ fn_: handleGetTasks, filters_: filters }} />
      </header>
      <section className="tasks-filter-bar" aria-label="Filtros de tareas">
        <div className="tasks-toolbar">
          <label className="tasks-search-control">
            <span>Buscar</span>
            <span className="tasks-search-input">
              <i className="bi bi-search" aria-hidden="true" />
              <input
                className="form-control"
                type="search"
                name="text"
                placeholder="Actividad o proyecto"
                value={filters.text || ""}
                onChange={handleFilters}
              />
            </span>
          </label>
          {dateFilters}
          <button
            type="button"
            className="btn tasks-filter-toggle"
            aria-expanded={openMoreFilters}
            aria-controls="tasks-additional-filters"
            onClick={() => setOpenMoreFilters(!openMoreFilters)}
          >
            <i className="bi bi-sliders" aria-hidden="true" />
            Filtros{activeFilters > 0 && <span className="tasks-filter-count">{activeFilters}</span>}
          </button>
          <TaskViewSwitch view={view} onChange={setView} />
          <button
            type="button"
            className="btn tasks-filter-toggle"
            aria-label="Actualizar lista"
            title="Actualizar lista"
            onClick={() => handleGetTasks({ ...filters, page })}
          >
            <i className="bi bi-arrow-clockwise" aria-hidden="true" />
          </button>
        </div>
        <div id="tasks-additional-filters" className="tasks-additional-filters" hidden={!openMoreFilters}>
          <FiltersMoreOptions
            filters={filters}
            handleFilters={handleFilters}
            pathName={pathName}
            usuariosTarea={usuariosTarea}
          />
        </div>
      </section>

      {tasksList[0]?.fecha_inicio &&
      tasksList[tasksList?.length - 1]?.fecha_fin &&
      pathName !== "tasks" ? (
        <div className="mt-2 ms-1">
          <span>
            <label>Fecha Inicio:</label>
            <span className="ms-1">
              {moment(tasksList[0]?.fecha_inicio).format("DD-MM-YYYY")}
            </span>
          </span>
          <span className="ms-2">
            <label>Fecha Fin:</label>
            <span className="ms-1">
              {moment(tasksList[tasksList?.length - 1]?.fecha_fin).format(
                "DD-MM-YYYY",
              )}
            </span>
          </span>
          <span className="ms-2">
            (
            {moment(tasksList[tasksList?.length - 1]?.fecha_fin).diff(
              moment(tasksList[0]?.fecha_inicio),
              "days",
            ) + 1}{" "}
            días)
          </span>
        </div>
      ) : (
        ""
      )}

      <div className="tasks-results">
        {view === "gantt" ? (
          <TasksGantt tasks={tasksList || []} users={usuariosTarea} onOpenTask={opens.handleOpenEdit} />
        ) : tasksList?.length > 0 ? (
          <table className="table table-hover tasks-table">
            <Thead
              tasksList={tasksList}
              openAll={openAll}
              handleOpenAll={handleOpenAll}
              isMobile={isMobile}
            />
            <tbody>
              {tasksList?.map((it) => (
                <RowTask
                  key={it.id}
                  it={it}
                  opens={opens}
                  tasksList={tasksList}
                  setTasksList={setTasksList}
                  handleRemoveTask={handleRemoveTask}
                  usuariosTarea={usuariosTarea}
                  pathName={pathName}
                  isMobile={isMobile}
                  handleCheckDone={handleCheckDone}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <h3 className="tasks-empty">
            {filters.time === "today" ||
            filters.time === "week" ||
            filters.time === "month" ? (
              <span>
                No hay tareas agendadas para{" "}
                {filters.time === "today"
                  ? "hoy."
                  : filters.time === "week"
                    ? "esta semana."
                    : "este mes."}
              </span>
            ) : (
              <span>No se encontraron tareas.</span>
            )}
          </h3>
        )}
      </div>
      <div className="row mt-4 mb-2">
        <div className="col d-flex justify-content-start">
          <Pagination
            count={100}
            page={page}
            size="small"
            onChange={handleChangePage}
          />
        </div>
      </div>
    </>
  );
};

const Thead = ({ tasksList, openAll, handleOpenAll, isMobile }) => {
  return (
    <thead>
      <tr className="text-center">
        <th scope="col" colSpan={3} className="text-start">
          <div className="d-flex justify-content-start">
            <span>Actividad ({tasksList?.length || 0})</span>
            {/* {openAll ?
                            <Link to="#" className="ms-5" onClick={handleOpenAll}>
                                <i className="bi bi-caret-down-fill"></i>
                                <label className="ms-1" style={{ cursor: 'pointer' }}>Cerrar todo</label>
                            </Link>
                            :
                            <Link to="#" className="ms-5" onClick={handleOpenAll}>
                                <i className="bi bi-caret-right-fill"></i>
                                <label className="ms-1" style={{ cursor: 'pointer' }}>Abrir todo</label>
                            </Link>
                        } */}
          </div>
        </th>
        {/* <th scope="col">Horas Estimadas</th> */}
        <th scope="col">Responsable</th>
        {!isMobile ? <th scope="col">Seguimiento</th> : ""}
        {!isMobile ? <th scope="col">Días</th> : ""}
        {/* {!isMobile ? <th scope="col">F. Inicio</th> : ''} */}
        <th scope="col">Vence</th>
        <th scope="col">Estado</th>
        {/* {!isMobile ? <th scope="col">Prioridad</th> : ''} */}
        <th scope="col"></th>
      </tr>
    </thead>
  );
};

const RowTask = ({
  it,
  opens,
  tasksList,
  setTasksList,
  handleRemoveTask,
  usuariosTarea,
  pathName,
  isMobile,
  handleCheckDone,
}) => {
  return (
    <tr
      style={{
        verticalAlign: "middle",
        color: it.estado === "completado" ? "green" : "",
        textTransform: "none",
      }}
    >
      <td colSpan={3} className="tasks-activity">
        <div className="d-flex flex-column justify-content-center align-items-start">
          <div
            className="d-flex flex-column justify-content-between align-items-start mt-2"
            style={{
              width: "100%",
              border: "none",
              color:
                it?.tipo === "hito" || it?.subs.length > 0
                  ? "#8E24AA"
                  : "#78717A",
            }}
          >
            <div className="d-flex justify-content-start align-items-center">
              <Link
                to=""
                onClick={() => opens.handleOpenEdit(it?.id)}
                className={
                  it.estado === "completado"
                    ? "p-link-hitos-done"
                    : "p-link-hitos"
                }
                style={{ color: it.estado === "completado" ? "green" : "" }}
              >
                <div className="p-link-project-name">
                  <span>{it.nombre}</span>
                  {it.tipo === "subtask" ? (
                    <Tooltip title="subtarea">
                      <span
                        className="ms-1 me-1"
                        style={{
                          textTransform: "none",
                          backgroundColor: "#8E24AA",
                          fontSize: "9px",
                          color: "white",
                          padding: "2px 4px",
                          borderRadius: "3px",
                        }}
                      >
                        ST
                      </span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
              </Link>

              {it.estado === "completado" ? (
                <Tooltip title="Tarea completada">
                  <Link
                    to=""
                    onClick={() => handleCheckDone(it.id)}
                    style={{ color: "green" }}
                  >
                    <i
                      className="bi bi-check-circle-fill ms-2"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Link>
                </Tooltip>
              ) : (
                <Tooltip title="Completar tarea">
                  <Link
                    to=""
                    onClick={() => handleCheckDone(it.id)}
                    style={{ color: "#4a24ab" }}
                  >
                    <i
                      className="bi bi-check-circle ms-2"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Link>
                </Tooltip>
              )}
            </div>

            {pathName === "tasks" && (
              <div className="tasks-project">
                {it.id_proyecto ? (
                  <Link to={`/ppto/${it.id_proyecto}`} target="_blank" rel="noopener noreferrer">
                    {it.project_name || "Ver proyecto"}
                  </Link>
                ) : "Tarea general"}
              </div>
            )}
            <div style={{ color: "gray" }}>
              {it.id_hito ? (
                <Link
                  to=""
                  style={{
                    textDecoration: "none",
                    fontSize: "10px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => opens.handleOpenEdit(it.id_hito)}
                >
                  {it.hito_nombre}
                </Link>
              ) : (
                ""
              )}

              {it.id_hito && it.tipo === "subtask" ? (
                <span className="ms-1 me-1">{">"}</span>
              ) : (
                ""
              )}

              {it.tipo === "subtask" ? (
                <Link
                  to=""
                  style={{
                    textDecoration: "none",
                    fontSize: "10px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => opens.handleOpenEdit(it.id_tarea)}
                >
                  {it.tarea_nombre}
                </Link>
              ) : (
                ""
              )}
            </div>

            {/* {(it.proyecccion_cant > 0 || it?.info_flow?.id_item_ppto) ?
                            <Link
                                to=""
                                style={{ marginTop: '2px' }}
                                className="p-link-hitos ms-2 d-flex justify-content-start align-items-end"
                                onClick={() => opens.handleOpenEditFlow(it)}
                            >
                                <i className="bi bi-link-45deg" style={{ fontSize: '12px' }}></i>
                                flujo ({it.proyecccion_cant > 1 ? 'varios' : moment(it?.info_flow?.fecha_proyeccion).format('DD-MM-YYYY')})
                            </Link>
                            :
                            it?.id_proyecto ?
                                <Link
                                    to=""
                                    style={{ textDecoration: 'none' }}
                                    onClick={() => opens.handleOpenEditFlow(it)}
                                >
                                    <i className="bi bi-link-45deg" style={{ fontSize: '12px' }}></i>
                                    <span style={{ textTransform: 'none', marginLeft: '2px' }}>Enlazar a flujo</span>
                                </Link> :
                                ''
                        } */}
          </div>

          {it?.subs.length > 0 && (
            <Link
              to=""
              onClick={() => {
                const listUpdated2 = tasksList.map((it2) => {
                  if (it2.id === it?.id) {
                    return {
                      ...it2,
                      show_subs: !it2.show_subs,
                    };
                  }

                  return it2;
                });

                setTasksList(listUpdated2);
              }}
              className="d-flex align-items-start d-flex align-items-center p-link-info-task"
            >
              <i
                className="bi bi-list-check ms-1"
                style={{ fontSize: "16px" }}
              ></i>
              <span style={{ fontSize: "12px", marginLeft: "2px" }}>
                {it?.subs.length}{" "}
                {`${it?.tipo === "hito" ? `${it?.subs.length === 1 ? "tarea" : "tareas"}` : `${it?.subs.length === 1 ? "subtarea" : "subtareas"}`}`}
              </span>
            </Link>
          )}
        </div>
      </td>
      <td className="text-center">
        {usuariosTarea?.find((ut) => ut.id === it?.id_responsable)?.nombre ||
          "---"}
      </td>

      {!isMobile ? (
        <td className="text-center">
          {usuariosTarea?.find((ut) => ut.id === it?.id_responsable_seguimiento)
            ?.nombre || "---"}
        </td>
      ) : (
        ""
      )}

      {!isMobile ? (
        <td className="text-center">
          {it?.subs?.length > 0 ? (
            <NumberFormat
              displayType={"text"}
              className="text-end"
              value={it.dias || 0}
              thousandSeparator=","
              decimalSeparator="."
              suffix=" días"
              decimalScale={0}
              fixedDecimalScale={0}
            />
          ) : (
            <NumberFormat
              displayType={"text"}
              className="text-end"
              value={it.dias || 0}
              thousandSeparator=","
              decimalSeparator="."
              suffix=" días"
              decimalScale={0}
              fixedDecimalScale={0}
            />
          )}
        </td>
      ) : (
        ""
      )}

      {/* {
                !isMobile ?
                    <td className="text-center">
                        {it?.fecha_inicio ? moment(it?.fecha_inicio).format('DD-MM-YYYY') : '---'}
                    </td> : ''
            } */}

      <td className="text-center">
        <TaskDeadline date={it.fecha_fin} status={it.estado} />
      </td>
      <td className="text-center">
        <TaskStatus status={it.estado} />
      </td>
      <td className="text-start" style={{ verticalAlign: "middle" }}>
        <Tooltip title="Eliminar tarea">
          <Link to="" onClick={() => handleRemoveTask(it, "hito")}>
            <i
              className="bi bi-trash"
              style={{ color: "gray", fontSize: "14px" }}
            ></i>
          </Link>
        </Tooltip>
      </td>
    </tr>
  );
};
